import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Modal from '../Modal'
import { pxToRem } from '../../utils'
import {
  Input,
  Select,
  Button,
  TextArea,
  InputError,
  FormControl,
  InputMaskDateTime,
  InputFile
} from '../Form'
import { connect } from 'react-redux'
import { color } from '../../utils'
import { productMapActions, inventoryActions } from '../../actions'
import { inventory } from '../../api'
import CurrencyFormat from 'react-currency-format'
import statusSuccessIcon from '../../assets/icons/status-success.svg'
import { dateTime } from '../../utils/format'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
const USE_OUTPUT_ATTACHMENTS = process.env.REACT_APP_USE_OUTPUT_ATTACHMENTS === 'y'

const InvoiceButton = styled(Button)`
  width: 20%;
  margin-top: 20px;  
`

const WrapperSelect = styled(FormControl)`
  margin-top: 20px;
  width: ${props => props.width};
  display: inline-block;
  color: ${color.secondary};
  padding: 0;
  label {
    font-size: ${pxToRem(16)};
    height: ${pxToRem(50)};
    line-height: ${pxToRem(50)};
  }
`

const WrapperInputWithError = styled(FormControl)`
  padding: 0;
  width: ${props => props.width};
  margin: ${props => props.margin};
`

const WrapperRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const Line = styled.hr`
  margin-top: 20px;
`

const SaveButton = styled(InvoiceButton)`
  margin-left: 2.5%;
  background-color: ${color.primary};
  border: 0;
`

const CancelButton = styled(InvoiceButton)`
  margin-left: 2.5%;
  background-color: #e84d4d;
  border: 0;
`

const WrapperAmountsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom:10px;
`

const FileInputContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  width: 100%;
  p {
    padding: auto 0;
    margin: 10px;
  }
`

const InvoiceLink = styled.a`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  cursor: pointer;
  color: ${color.secondary};
`

const WrapperIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
  background: ${color.success};

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: ${pxToRem('15px')}
  }
`

class InventoryOutput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inventory: {},
      productBatches: [],
      selectedBatch: {},
      open: false,
      submitted: false,
      currentAreaId: null,
      currentUserId: null,
      productError: null,
      amountError: null,
      batchError: null,
      amountPackageError: null,
      totalAmountError: null,
      transactionDateError: null
    }
  }

  componentDidMount() {
    this.props.fetchProductList(this.props.currentAreaId)
  }

  componentWillReceiveProps(props) {
    if(this.props.currentAreaId !== props.currentAreaId) {
      this.props.fetchProductList(props.currentAreaId)
    }
    this.setState(state => ({
      inventory: props.inventoryItem,
      productBatches: [],
      selectedBatch: {},
      productCabinets: '',
      currentAreaId: props.currentAreaId,
      currentUserId: props.currentUserId,
      open: props.open,
      productError: null,
      amountError: null,
      batchError: null,
      totalAmountError: null,
      transactionDateError: null
    }))

    this.setDefaultValue()
  }

  setDefaultValue() {
    this.setState(state => ({
      inventory: {
        amount: 0,
        amountPackage: 0,
        transactionDate: dateTime(new Date()),
        areaId: this.state.currentAreaId,
        userId: this.state.currentUserId, 
        ...state.inventory
      }
    }))
  }

  createAt = () => {
    return new Date().toLocaleDateString('pt-BR')
  }

  closeModal = () => {
    this.props.closeMethod()
  }

  handleProduct = async product => {
    this.setDefaultBatches()
    const items = await this.getProductBatches(product.value, this.state.currentAreaId)
    this.setState(state => ({
      productError: null,
      inventory: {
        ...state.inventory,
        measure: product.measure,
        productId: product.value,
      },
      productBatches: items,
      productCabinets: product.cabinets
    }))
  }

  getProductBatches = async (productId, areaId) => {
    const response = await inventory.getProductBatches(productId, areaId)
    const { item: items } = response.data

    return items
  }

  setDefaultBatches = () => {
    this.setState(state => ({
      inventory: {
        ...state.inventory,
        batch: '',
      },
      productBatches: [],
      selectedBatch: {}
    }))
  }

  handleObservation = observation => {
    this.setState(state => ({
      inventory: {
        ...state.inventory,
        observation
      }
    }))
  }

  handleBatch = batch => {
    this.setState(state => ({
      batchError: null,
      inventory: {
        ...state.inventory,
        batch: batch.value
      },
      selectedBatch: batch
    }))
  }

  handleAmount = amount => {
    const totalAmount = amount * this.state.inventory.amountPackage || amount
    this.setState(state => ({
      amountError: null,
      totalAmountError: null,
      inventory: {
        ...state.inventory,
        amount,
        totalAmount
      }
    }))
  }

  handleAmountPackage = amountPackage => {
    const totalAmount = amountPackage * this.state.inventory.amount || this.state.inventory.totalAmount
    this.setState(state => ({
      amountError: null,
      totalAmountError: null,
      inventory: {
        ...state.inventory,
        amountPackage,
        totalAmount
      }
    }))
  }

  productFullName = product => {
    const provider = product && product.provider && product.provider !== '---' ? " - (" + product.provider + ")" : ''
    return product.name + provider
  }

  handleTransactionDate = transactionDate => {
    this.setState(state => ({
      inventory: {
        ...state.inventory,
        transactionDate
      }
    }))
  }

  handleSubmit = event => {
    event.preventDefault()

    this.setState({ submitted: true })

    const { inventory } = this.state

    if (this.isEditMode()) {
      this.props.editInventoryOutput(inventory, this.props.searchText, this.props.pagination)
      this.closeModal()
      return
    }

    const batchValid = this.batchValid()
    const productValid = this.validProduct()
    const amountValid = this.validAmount()
    const amountPackageValid = this.validAmountPackage()
    const transactionDateValid = this.validTransactionDate()

    if (batchValid
      && productValid
      && amountValid
      && amountPackageValid
      && transactionDateValid
    ) {
      this.props.addInventoryOutput(inventory, this.props.searchText, this.props.pagination)
      this.closeModal()
    }
  }

  batchValid = () => {
    const { batch } = this.state.inventory
  
    if (!batch) {
      this.setState(state => ({
        batchError: 'Lote é obrigatório'
      }))
      return false
    }
    this.setState(state => ({
      batchError: undefined
    }))
    return true
  }

  validProduct = () => {
    const { productId } = this.state.inventory

    if (!productId) {
      this.setState(state => ({
        productError: 'Produto é obrigatório'
      }))
      return false
    }
    this.setState(state => ({
      productError: undefined
    }))
    return true
  }

  validAmount = () => {
    const { amount, amountPackage } = this.state.inventory
    const { currentStock } = this.state.selectedBatch || {}


    if (!amount) {
      this.setState(state => ({
        amountError: 'Quantidade é obrigatório'
      }))
      return false
    }
    
    if (amount <= 0) {
      this.setState(state => ({
        amountError: 'Quantidade inválida'
      }))
      return false
    }
    
    const enoughStock = this.checkEnoughStock(amount, amountPackage, currentStock)

    if (!enoughStock) {
      this.setState(state => ({
        amountError: null,
        totalAmountError: 'Estoque insuficiente'
      }))
      return false
    }

    this.setState(state => ({
      amountError: null,
      totalAmountError: null
    }))
    return true
  }

  validAmountPackage = () => {
    const { amountPackage } = this.state.inventory

    if (amountPackage < 0) {
      this.setState(state => ({
        amountPackageError: 'Quantidade inválida'
      }))
      return false
    }

    this.setState(state => ({
      amountPackageError: null
    }))
    return true
  }

  validTransactionDate = () => {
    const fieldError = 'transactionDateError'
    const { transactionDate } = this.state.inventory
    if (transactionDate) {
      const day = transactionDate[0] + transactionDate[1]
      const month = transactionDate[3] + transactionDate[4]
      const year = transactionDate[6] + transactionDate[7] + transactionDate[8] + transactionDate[9]
      const hour = transactionDate[11] + transactionDate[12]
      const minutes = transactionDate[14] + transactionDate[15]

      return (
        this.validDay(day, fieldError) 
        && this.validMonth(month, fieldError)
        && this.validTime(hour, minutes, fieldError)
        && this.validTimeFuture(year, month, day, hour, minutes, fieldError)
      )
    }
    return true
  }

  validDay = (day, fieldError) => {
    if (day > 31 || day < 1) {
      this.setState(state => ({
        [fieldError]: 'Data inválida'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validMonth = (month, fieldError) => {
    if (month > 12 || month < 1) {
      this.setState(state => ({
        [fieldError]: 'Data inválida'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validFuture = (day, month, year, fieldError) => {
    const date = this.createAt()
    const currentDay = date[0] + date[1]
    const currentMonth = date[3] + date[4]
    const currentYear = date[6] + date[7] + date[8] + date[9]
    if (
      currentYear < year ||
      (currentMonth < month && currentYear < year) ||
      (currentDay < day && currentMonth <= month && currentYear <= year)
    ) {
      this.setState(state => ({
        [fieldError]: 'Data não deve ser futura'
      }))
      return false
    }
      this.setState(state => ({
        [fieldError]: null
      }))
      return true
  }

  validHour = (hour, fieldError) => {
    if (hour.includes('_') || hour > 24 || hour < 0) {
      this.setState(state => ({
        [fieldError]: 'Horas inválidas'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validMinutes = (minutes, fieldError) => {
    if (minutes.includes('_') || minutes > 59 || minutes < 0) {
      this.setState(state => ({
        [fieldError]: 'Minutos inválidos'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validTime = (hour, minutes, fieldError) => {
    return this.validHour(hour, fieldError) && this.validMinutes(minutes, fieldError)
  }

  validTimeFuture = (year, month, day, hour, minutes, fieldError) => {
    const input = new Date(year, month - 1, day, hour, minutes)
    const current = new Date()
    if (input <= current) {
      this.setState(state => ({
        [fieldError]: null
      }))
      return true
    }
    this.setState(state => ({
      [fieldError]: 'Data não deve ser futura'
    }))
    return false
  }

  checkEnoughStock = (amount, amountPackage, currentStock) => {
    if (amountPackage &&  amountPackage != 0) {
      if (amount * amountPackage <= currentStock) {
        return true
      }
      return false
    }

    if (amount <= currentStock) {
      return true
    }

    return false
  }

  isEditMode = () => {
    return this.props.method === 'edit'
  }

  uploadFile = (event, callback) => {
    let file = event.target.files[0]
    let reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = e => { callback(e.target.result, file.name) }
  }

  uploadInvoice = event => {
    this.uploadFile(event, (result, fileName) => {
      this.setState(state => ({
        inventory: {
          ...state.inventory,
          invoice: result,
          invoiceFileName: fileName
        }
      }))
    })
  }

  uploadCertificate = event => {
    this.uploadFile(event, (result, fileName) => {
      this.setState(state => ({
        inventory: {
          ...state.inventory,
          certificate: result,
          certificateFileName: fileName
        }
      }))
    })
  }

  openFile = url => {
    if (!url) return
    const isAbsolute = /^https?:\/\//i.test(url)
    window.open(isAbsolute ? url : `${API_BASE_URL}${url}`, '_blank')
  }

  renderAttachments = () => {
    const { inventory } = this.state
    const { uploadInvoice, uploadCertificate, openFile } = this

    return (
      <Fragment>
        <FileInputContent>
          <InputFile
            id={'invoiceInput'}
            type={'file'}
            width={'50%'}
            accept={'.pdf'}
            label="Escolha a nota fiscal"
            onChange={event => { uploadInvoice(event) }}
          />
          <p>{inventory.invoiceFileName}</p>
          {inventory.invoice_url && inventory.invoice_url !== '---' && (
            <InvoiceLink href="javascript:void(0)" onClick={e => openFile(inventory.invoice_url)}>
              <WrapperIcon>
                <img src={statusSuccessIcon} />
              </WrapperIcon>
              Visualizar Nota Fiscal
            </InvoiceLink>
          )}
        </FileInputContent>

        <FileInputContent>
          <InputFile
            id={'certificateInput'}
            type={'file'}
            width={'50%'}
            accept={'.pdf'}
            label="Escolha o certificado"
            onChange={event => { uploadCertificate(event) }}
          />
          <p>{inventory.certificateFileName}</p>
          {inventory.certificate_url && inventory.certificate_url !== '---' && (
            <InvoiceLink href="javascript:void(0)" onClick={e => openFile(inventory.certificate_url)}>
              <WrapperIcon>
                <img src={statusSuccessIcon} />
              </WrapperIcon>
              Visualizar Certificado
            </InvoiceLink>
          )}
        </FileInputContent>
      </Fragment>
    )
  }

  render() {
    const {
      name,
      open = false, 
      size,
      title,
      method,
      loading = false,
      closeMethod,
      currentUser,
      currentArea,
      productList
    } = this.props
    
    const { 
      createAt, 
      closeModal,
      handleBatch,
      handleAmount,
      handleProduct,
      handleObservation,
      handleAmountPackage,
      productFullName,
      handleSubmit,
      isEditMode
    } = this

    const { 
      inventory,
      productBatches,
      selectedBatch,
      submitted,
      batchError, 
      productError, 
      amountError,
      amountPackageError,
      totalAmountError,
      transactionDateError,
      productCabinets
    } = this.state

    return (
      <Modal
        title={title}
        name={name}
        open={open}
        size={size}
        method={method}
        loading={loading}
        closeMethod={closeMethod}
      >
        <form onSubmit={handleSubmit} >
          {isEditMode() ? (
            <Fragment>
              {USE_OUTPUT_ATTACHMENTS && this.renderAttachments()}
              <Line/>
              <WrapperRow>
                <Input
                  label={'RESPONSÁVEL'}
                  display={'inline-block'}
                  value={inventory.user_name || currentUser}
                  width={'25%'}
                  margin={'20px 0 0 0'}
                  readonly={'readonly'}
                />
                <Input
                  label={'DATA SAÍDA'}
                  display={'inline-block'}
                  value={inventory.transaction_date || ''}
                  width={'25%'}
                  margin={'20px 0 0 5%'}
                  readonly={'readonly'}
                />
                <CancelButton type={'button'} onClick={closeModal}>
                  Cancelar
                </CancelButton>
                <SaveButton>
                  Salvar
                </SaveButton>
              </WrapperRow>
            </Fragment>
          ) : (
          <Fragment>
          <WrapperRow>
            <WrapperSelect width={'100%'}>
              <Select
                placeholder={'PRODUTO'}
                disabled={isEditMode}
                onChange={event => { handleProduct(event) }}
                options={productList.map(product => {
                  return { 
                    label: productFullName(product), 
                    value: product.id, 
                    measure: product.measure,
                    cabinets: product.cabinets
                  }
                })}
              />
              {submitted && productError ? <InputError>{productError}</InputError> : ''}
            </WrapperSelect>
          </WrapperRow>
          <WrapperRow>
            <WrapperSelect width={'50%'}>
              <Select
                placeholder={'LOTE / IDENTIFICAÇÃO'}
                disabled={isEditMode}
                onChange={event => { handleBatch(event) }}
                options={productBatches.map(item => { 
                  return {
                    label: item.batch,
                    value: item.batch,
                    currentStock: item.amount
                  } 
                })}
              />
              {submitted && batchError ? <InputError>{batchError}</InputError> : ''}
            </WrapperSelect>
            <Input
              label={'ESTOQUE'}
              disabled={isEditMode}
              display={'inline-block'}
              value={selectedBatch.currentStock ? selectedBatch.currentStock.toLocaleString('pt-BR', { minimumFractionDigits: 5 }) : ''}
              width={'48%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
            />
            </WrapperRow>
          <WrapperAmountsRow>
            <WrapperInputWithError width={'20%'} margin={'20px 0 0 0'}>
              <CurrencyFormat
                thousandSeparator={'.'}
                decimalSeparator={false}
                decimalScale={0}
                allowNegative={false}
                customInput={Input}
                margin={'3px 0 0 0'}
                label={'QTD. EMBALAGEM'}
                floatValue={inventory.amountPackage || inventory.amount_package}
                onValueChange={(values) => {
                  handleAmountPackage(values.floatValue)
                }}
                disabled={isEditMode}
              />
              {submitted && amountPackageError ? <InputError>{amountPackageError}</InputError> : ''}
            </WrapperInputWithError>
            <WrapperInputWithError width={'20%'} margin={'20px 0 0 0'}>
            <CurrencyFormat
                thousandSeparator={'.'}
                decimalSeparator={','}
                decimalScale={5}
                allowNegative={false}
                customInput={Input}
                margin={'3px 0 0 0'}
                label={'QTD.'}
                onValueChange={(values) => {
                  handleAmount(values.floatValue)
                }}
                floatValue={inventory.amount || ''}
                disabled={isEditMode}
              />
              {submitted && amountError ? <InputError>{amountError}</InputError> : ''}
            </WrapperInputWithError>
            <Input
              disabled={isEditMode}
              label={'UN. MEDIDA'}
              display={'inline-block'}
              value={inventory.measure || ''}
              width={'20%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
            />
            <WrapperInputWithError width={'20%'} margin={'20px 0 0 0'}>
              <CurrencyFormat
                thousandSeparator={'.'}
                decimalSeparator={','}
                decimalScale={5}
                allowNegative={false}
                customInput={Input}
                margin={'3px 0 0 0'}
                label={'TOTAL A SAIR'}
                value={inventory.totalAmount ? inventory.totalAmount : ''}
                readonly={'readonly'}
                disabled={isEditMode}
              />
              {submitted && totalAmountError ? <InputError>{totalAmountError}</InputError> : ''}
            </WrapperInputWithError>
          </WrapperAmountsRow>
          <WrapperRow>
            <Input
              disabled={isEditMode}
              label={'ARMÁRIOS'}
              display={'inline-block'}
              value={productCabinets || ''}
              width={'100%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
            />
          </WrapperRow>

          {USE_OUTPUT_ATTACHMENTS && this.renderAttachments()}

          <TextArea
            disabled={isEditMode}
            value={ inventory.observation === '---' ? '' : inventory.observation }
            onChange={event => { handleObservation(event.target.value) }}
            display={'inline-block'}
            margin={'20px 0 0 0'}
            label={'OBS.'}
          />
          <Line/>
          <WrapperRow>
            <Input
              disabled={isEditMode}
              label={'RESPONSÁVEL'}
              display={'inline-block'}
              value={currentUser}
              width={'15%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
            />
            <Input
              disabled={isEditMode}
              label={'ÁREA'}
              display={'inline-block'}
              value={currentArea}
              width={'15%'}
              margin={'20px 0 0 5%'}
              readonly={'readonly'}
              />
            <WrapperInputWithError width={'15%'} margin={'20px 0 0 5%'}>
              <InputMaskDateTime
                onChange={event => {
                  this.handleTransactionDate(event.target.value)
                }}
                label={'DATA SAÍDA'}
                type={'text'}
                value={inventory.transactionDate}
              />
              {submitted && transactionDateError ? (
                <InputError>{transactionDateError}</InputError>
              ) : (
                ''
              )}
            </WrapperInputWithError>
            <CancelButton onClick={closeModal}>
              Cancelar
            </CancelButton>
            <SaveButton>
              Salvar
            </SaveButton>
          </WrapperRow>
          </Fragment>
          )}
        </form>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.userName,
  currentUserId: state.auth.userId,
  currentArea: state.auth.areaName,
  currentAreaId: state.auth.areaId,
  productList: state.productMap.items,
  searchText: state.search.searchText,
  pagination: state.inventory.pagination
})

const mapDispatchToProps = dispatch => {return {
  fetchProductList: areaId => {
    dispatch(productMapActions.fetchCollectionProductsByInventory(areaId))
  },
  addInventoryOutput: (inventory, searchText, pagination) => {
    dispatch(inventoryActions.addInventoryOutput(inventory, searchText, pagination))
  },
  editInventoryOutput: (inventory, searchText, pagination) => {
    dispatch(inventoryActions.editInventoryOutput(inventory, searchText, pagination))
  }
}}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryOutput)



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryOutputModal.js